<template>
    <div class="sign">
        <div class="addViewexam" id="exam_add">
        <h1 v-if="titleExam==false">新增试题</h1>
        <h1 v-else>编辑试题</h1>
        <div class="nav">
                <el-menu :default-active="activeIndex" class="el-menu-demo lf" mode="horizontal" text-color="#333">
                    <el-menu-item index="1"><router-link :to="{name:'sign',query:{q_id:id}}">单选题</router-link></el-menu-item>
                    <el-menu-item index="2"><router-link :to="{name:'mcq',query:{q_id:id}}">多选题</router-link></el-menu-item>
                    <el-menu-item index="3"><router-link :to="{name:'tfai',query:{q_id:id}}">判断题</router-link></el-menu-item>
                    <el-menu-item index="4"><router-link :to="{name:'exercise',query:{q_id:id}}">填空题</router-link></el-menu-item>
                    <!-- <el-menu-item index="5"><router-link :to="{name:'questions',query:{q_id:id}}">简答题</router-link></el-menu-item> -->
                </el-menu>
            </div>
            <div class="testcontent">
                <h2>试题内容</h2>
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>
<script>
    export default{
        name:'addexam',
         data() {
            return {
                activeIndex: '1',
                Curl:'',
                titleExam:false,
                id:this.$route.query.q_id
            };
        },
        mounted(){
            if(this.id){
                this.titleExam=true
                console.log(this.titleExam)
            }
            else{
                this.titleExam=false
            }
            if(this.$route.name == 'addexam'){
                this.$router.push({path:'/addexam/sign'})
            }
            if (this.$route.name == 'sign'){
                this.activeIndex='1'
            }
            else if (this.$route.name == 'mcq'){
                this.activeIndex='2'
            }
            else if (this.$route.name == 'tfai'){
                this.activeIndex='3'
            }
            else if (this.$route.name == 'exercise'){
                this.activeIndex='4'
            }
            else{
                this.activeIndex='5'
            }
        },
        watch:{
                $route(to,from){
                   if(this.$route.name == 'addexam'){
                        this.$router.push({path:'/addexam/sign'})
                        this.activeIndex='1'
                    }
                }
            },
    }
</script>
<style>
   @import "../../assets/css/add_exam.css";

</style>


// WEBPACK FOOTER //
// src/components/examView/addexam.vue